import React from "react";
import PropTypes from "prop-types";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Chip,
} from "@material-ui/core";

// Material-UI v4 multi-select that renders the current selection as chips
// and the option list as checkbox rows. Options use {id, name} shape — the
// same shape returned by Zone Admin CRUD endpoints, so no transformation is
// needed at the call site.

const MultiSelectChips = ({
  label,
  name,
  value,
  options,
  onChange,
  onBlur,
  disabled,
  fullWidth,
  variant,
}) => {
  const labelId = `${name}_label`;
  const inputId = `${name}_input`;
  const safeValue = value || [];

  return (
    <FormControl fullWidth={fullWidth} variant={variant}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        multiple
        labelId={labelId}
        id={inputId}
        label={label}
        name={name}
        value={safeValue}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        renderValue={(selected) => (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
            {selected.map((id) => {
              const opt = options.find((o) => o.id === id);
              return (
                <Chip
                  key={id}
                  size="small"
                  label={opt ? opt.name : id}
                />
              );
            })}
          </div>
        )}
      >
        {options.map((opt) => (
          <MenuItem key={opt.id} value={opt.id}>
            <Checkbox checked={safeValue.indexOf(opt.id) > -1} />
            <ListItemText primary={opt.name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

MultiSelectChips.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.array,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  variant: PropTypes.string,
};

MultiSelectChips.defaultProps = {
  value: [],
  onBlur: undefined,
  disabled: false,
  fullWidth: true,
  variant: "outlined",
};

export default MultiSelectChips;
